const isUnifiedProfilePhotoEnabled = (): boolean => {
	const unifiedProfilePhotoMatch =
		typeof document !== 'undefined'
			? document.cookie.match(/(?:^|;\s*)UNIFIED_PROFILE_PHOTO=([^;]*)/i)
			: null;

	return !!(
		unifiedProfilePhotoMatch &&
		decodeURIComponent(unifiedProfilePhotoMatch[1]).trim().toLowerCase() ===
			'true'
	);
};

export default isUnifiedProfilePhotoEnabled;
